import { getEmbedConfigurationValueOrDefault } from 'modules/embed/selectors'
import { getEmbedLocale, getUseWidgetLocaleForGDPR } from 'modules/embed/utils'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { isNilOrEmpty } from 'utils'
import { getBrowserContext } from 'utils/context'
import { getMatchingLocaleForLanguage } from 'utils/i18n'
import { normalizeProtocolForUrl } from 'utils/url'

const DEFAULT_POLICY = {
  noPolicy: true,
  normalizedPolicyLink: '',
  message: '',
  giveConsentLabel: '',
  declineConsentLabel: '',
  consentDeclinedMessage: '',
  privacyPolicyLink: '',
  privacyPolicyLinkText: '',
}

const useResolvePrivacyPolicy = () => {
  const dataProtection =  useSelector(state => getEmbedConfigurationValueOrDefault(state, 'dataProtection', {}))
  const [currentPolicy, setCurrentPolicy] = useState(DEFAULT_POLICY)
  const { locale: browserLocale } = getBrowserContext()

  useEffect(() => {
    const resolvePolicy = () => {
      if(isNilOrEmpty(dataProtection) || isNilOrEmpty(dataProtection.policies)) {
        setCurrentPolicy(DEFAULT_POLICY)
        return
      }

      const useWidgetLocale = getUseWidgetLocaleForGDPR()
      const dataProtectionDefault = dataProtection.default || 'en'
      const locale = useWidgetLocale ? getEmbedLocale() : browserLocale || dataProtectionDefault
      const availablePolicyLocales = Object.keys(dataProtection.policies)

      const matchingLocale = getMatchingLocaleForLanguage(locale, availablePolicyLocales, dataProtectionDefault)
      const matchingPolicy = dataProtection.policies[matchingLocale]

      if (isNilOrEmpty(matchingPolicy)) {
        setCurrentPolicy(DEFAULT_POLICY)
        return
      }

      const noPolicy = !matchingPolicy.privacyPolicyLink || !matchingPolicy.privacyPolicyLinkText || !matchingPolicy.privacyPolicyAlwaysOn
      const normalizedPolicyLink = normalizeProtocolForUrl(matchingPolicy.privacyPolicyLink)

      setCurrentPolicy({
        ...matchingPolicy,
        noPolicy,
        normalizedPolicyLink
      })
    }

    resolvePolicy()
  }, [browserLocale, dataProtection, dataProtection.default, dataProtection.policies])

  return currentPolicy
}

export default useResolvePrivacyPolicy
